// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1842":"f90c042a","5801":"227955cf"}[chunkId] + ".chunk.css";
};